module.exports = __webpack_public_path__ + "static/media/state-13.f72b757f.jpg";